import { defineStore } from 'pinia'
import jpserve           from '@/services/jpserve.js'
import { useAuthStore }  from '@/stores/auth.js'

export const useJackpotTokensStore = defineStore('jackpotTokens', {
  state: () => ({
    MB8: 0,
    loading: false,
    error: null,
  }),
  actions: {
    async fetchMB8() {
      this.loading = true
      this.error   = null

      const authStore = useAuthStore()
      const apiKey    = authStore.user?.auth || ''

      if (!apiKey) {
        this.loading = false
        return
      }

      try {
        const authStore = useAuthStore()
        const apiKey = authStore.user?.auth ?? ''

        const url = `${import.meta.env.VITE_BASE_JACKPOT_URL}/mb8/balance`
        const response = await jpserve.get(url, {
          headers: apiKey ? { 'api-key': apiKey } : {}
        })

        const payload = response.data

        this.MB8 = payload.balance ?? 0

      } catch (err) {
        console.error('Failed to fetch MB8 ticket balance', err)
        this.error = err.message || 'Unknown error'
      } finally {
        this.loading = false
      }
    }
  }
})
